import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

/**
 * Renders FAQ structured data (JSON-LD) in the document head via react-helmet-async.
 * Reads FAQ items from the active locale's translation file and outputs
 * schema.org/FAQPage markup for search engine rich snippets.
 */
export default function FaqStructuredData() {
  const { t } = useTranslation();
  const faqItems = t('faq.items', { returnObjects: true });

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: Array.isArray(faqItems)
      ? faqItems.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        }))
      : [],
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
